<template>
  <div class="has-action-bar">
    <div class="tabs-border">
      <ul class="tabs__navigation ml-4">
        <li
          v-for="(tab, index) in tabs"
          class="tabs__navigation__item"
          :class="{ 'tabs__navigation__item--active': activeTab === tab }"
          @click="activeTab = tab"
          v-text="tab"
        />
      </ul>
    </div>

    <outreach-list v-if="activeTab === 'list'" @switch-tab="switchTab"/>
    <outreach-analytics v-else-if="activeTab === 'analytics'"/>
    <outreach-settings v-else/>
  </div>
</template>

<script>
  import OutreachList from './Outreach/OutreachList.vue'
  import OutreachAnalytics from './Outreach/OutreachAnalytics.vue'
  import OutreachSettings from './Outreach/OutreachSettings.vue'
  import { defineComponent } from 'vue'

  export default defineComponent({
    components: {
      OutreachList,
      OutreachAnalytics,
      OutreachSettings,
    },
    data () {
      return {
        activeTab: 'list',
      }
    },
    computed: {
      tabs () {
        return ['list', 'analytics', 'settings']
      },
    },
    methods: {
      switchTab (tab) {
        this.activeTab = tab
      },
    },
  })
</script>
